module.exports = __webpack_public_path__ + "static/media/pink-white-flower-large.60286a8e.jpg";